import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {catchError, map, throwError} from 'rxjs';
import {AppConfigurationService} from '../base/appConfiguration.service';

import {ToastrService} from 'ngx-toastr';

@Injectable({
  providedIn: 'root',
})
export class EmailContactService {
  constructor(
    private httpClient: HttpClient,
    private appConfigurationService: AppConfigurationService,
    private toastr: ToastrService,
  ) {}

  onSendEmailComplice(model: any, captchaToken: any) {
    const headers = new HttpHeaders({
      'X-Recaptcha': captchaToken,
    });
    return this.httpClient
      .post<Number>(`${this.appConfigurationService.apiBaseUrl}/Administration/SendEmailComplice`, model, {headers})
      .pipe(
        map(result => {
          return result;
        }),

        catchError(err => {
          return throwError(() => new Error(err || 'Erro no servidor'));
        }),
      );
  }

  onSendLeadEnterprise(model: any) {
    return this.httpClient
      .post<Number>(`https://back-end-stage.azurewebsites.net/api/Auth/SendLeadEnterprise`, model)
      .pipe(
        map(result => {
          return result;
        }),

        catchError(err => {
          return throwError(() => new Error(err || 'Erro no servidor'));
        }),
      );
  }
}
